<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="form-group">
    <label i18n for="account">{{ label }}</label>
    <div class="selected-wrapper d-flex">
        <div class="selected-item pr-5" *ngIf="value">
            {{ value?.name }}
        </div>
        <div class="selected-action btn-link" (click)="toggleSelectableTable()">
            <span *ngIf="showSelectabletable;">
                Hide Organizations List
            </span>
            <span *ngIf="!showSelectabletable">
                Show Organizations List
            </span>
        </div>
    </div>
</div>

<div class="selectable-table" *ngIf="showSelectabletable" >
        <app-data-table-ajax
            columnMode="force"
            url="/accounts"
            limit="5"
            responseKey="accounts"
            [columns]="accountsTableColumns"
            (rowClicked)="onSelectAccount($event)">
        </app-data-table-ajax>
    </div>


// WEBPACK FOOTER //
// ./src/app/access-management/shared/selectable-field/selectable-field.component.html